import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { DataService } from '../../data.service';
import { environment } from '../../../environments/environment';
import {c, e} from "@angular/core/src/render3";

@Component({
  selector: 'lc-ids-page',
  templateUrl: './ids-page.component.html',
  styleUrls: ['./ids-page.component.scss']
})
export class IdsPageComponent implements OnInit {

  qr_code: string;
  loading =  false;

  sales_reps  = [];
  use_scanner = environment['use_scanner'];

  sales_email: string;

  constructor(public dataService: DataService, private route: ActivatedRoute) { }

  ngOnInit() {
    let env_sales_reps = environment['sales_reps'];
    if(!!env_sales_reps && !!Array.isArray(env_sales_reps)) {
      this.sales_reps = env_sales_reps;
    }
    if(!!env_sales_reps && !Array.isArray(env_sales_reps)){
      this.dataService.getUserForCode(env_sales_reps).subscribe(parent => {
        this.sales_reps = [];
        let name: string;
        if( !!parent && !!parent.sub_users ){
          for( const u of parent.sub_users ){
            if(!!u.email && u.email.indexOf('@philips') > -1) {

              if(!u.last_name || u.last_name == 'test' || u.last_name == 'null'){
                name = u.email.split('@')[0].split('.').slice(-1)[0];
                name += ', ' +  u.email.split('@')[0].split('.').slice(0,-1).join(' ');
              } else {
                name = `${u.last_name}, ${u.first_name}`;
              }
              this.sales_reps.push({email: u.email, name: name});
            }
          }
          this.sales_reps.sort(
            (a,b) => {
              if( a.name.toLowerCase() <  b.name.toLowerCase() ) return -1;
              if( a.name.toLowerCase() >  b.name.toLowerCase() ) return +1;
              return 0;
            });
        }
      });

    }
    this.route.params.subscribe(params =>{
      let super_user_id = params['pid'];
      this.dataService.remarks_by = super_user_id;
      if( !!this.sales_reps && this.sales_reps.indexOf(super_user_id) == -1){
        this.sales_reps.unshift(super_user_id);
        this.sales_rep_changed();
      }
      this.route.queryParams.subscribe(params =>{
        let encoded_mail = params['m']
        if( !!encoded_mail ){
          try{
            let sales_user_mail = window.atob(encoded_mail);
            if (!!sales_user_mail ){
              this.sales_email = sales_user_mail;
              this.dataService.remarks_by = this.sales_email;
            }
          } catch (e) {
            // not a correctly encode email ?
          }
        }
      });
    });
    if( !!this.dataService.store_parents_locally ){
      this.count_locations(true); 
    } else {
      this.clear_locations();
    }
  }

  sales_rep_changed(){
    if(document.location.hostname !== 'localhost'){
      if( this.dataService.remarks_by.startsWith('TEST') && !this.dataService.NAMESPACE.endsWith('-TST') ){
        this.dataService.NAMESPACE += '-TST';
      }
      if( !this.dataService.remarks_by.startsWith('TEST') && !!this.dataService.NAMESPACE.endsWith('-TST') ){
        this.dataService.NAMESPACE = this.dataService.NAMESPACE.split('-TST')[0];
      }
    }
  }

  count_locations(load: boolean){
    this.dataService.local_db.locations.count().then( (cnt) => {
        
      this.dataService.known_locations = cnt;
      this.loading = false;
      
    }).catch(err => {
      this.dataService.known_locations = -2;
      this.loading = false;
      console.warn(err);
    })
  }

  // process result here
  OnScanResult(scanresult: string) {
    this.qr_code = scanresult;
  }
  load_all_locations(){
    if( !!this.dataService.store_parents_locally ){
      for( const country of this.dataService.know_countries ){
        this.load_locations_for_country(country.name);
      }
    } else {
      this.clear_locations();
    }
  }

  load_locations_for_country(country: string){
    this.loading = true;
    let count = 0;
    let stored = 0;
    let errors = 0;
    this.dataService.getUsersForPostalcode('TSV', country.toLowerCase()).subscribe(data => {
      let tsv_data = <string>data;
      let locs = [];

      for( let line of tsv_data.split(/\r|\n|\r/) ){
        let flds = line.split('\t');
        if( !flds ) continue;

        let loc;
        if( flds.length == 7){
          // DE / AT format
          if ( !flds[6] ) continue;
          loc = {ext_id: flds[0], company: flds[1], address: flds[2], city: flds[3], postalcode: flds[4], country: flds[5], id: flds[6] };
        }
        if( flds.length == 12){
          // ES format
          loc = {id: flds[7] + '-' + flds[0], ext_id: flds[0], company: flds[1], address: flds[2], city: flds[6], postalcode: flds[7], country: flds[9], email: flds[10], phone: flds[11]};
          // add extra address fields of needed
          for( const i of [3,4,5]){
            if(!!flds[i]){
              loc.address += '\n' + flds[i];
            }
          }
        }

        locs.push(loc);
        count++;
        // if( count > 10000) break;
        // this.dataService.local_db.locations.put(loc).then( () => {
        //   stored++;
        // }).catch(err=>{
        //   errors++;
        //   console.warn(err);
        // })
      }
      this.dataService.local_db.locations.bulkPut(locs).then( () => {
          this.count_locations(false);
        }).catch(err=>{
          this.count_locations(false);
          console.warn(err);
        });
    })
  }

  clear_locations(){
    this.loading = true;
    this.dataService.local_db.locations.clear().then( () => {
      this.count_locations(false);
    }).catch(err=>{
      this.count_locations(false);
      console.warn(err);
    });
  }

}



// WEBPACK FOOTER //
// /Users/matthijs/projects/PHILIPS/philips-dental-pro/shop/src/app/pages/ids-page/ids-page.component.ts